import { SignedDocument } from "../types";

export const getIsDocumentValid = (document: SignedDocument) =>
  !document.documentStatus.errorText && !document.signatureInfo.error;
